import md5 from "md5";
import { getLayerIdByName } from "../lib/utils";
import {
  arrangeLayersZIndex,
  removeLayerById,
  sortMapLayers,
} from "../components/map/mapUtils";
import { cloneDeep } from "lodash";
import { removeNodeAtPath, walk } from "react-sortable-tree";

const initialState = window["appConfig"]
  ? [...window["appConfig"]().layerTree]
  : [];
export default function layerTreeReducer(state = initialState, action) {
  switch (action.type) {
    case "layer/add":
      {
        let newState = [
          ...state,
          {
            id: action.payload.id,
            title: action.payload.title,
            type: "layer",
            expanded: true,
            checked: true,
            layer: action.payload,
          },
        ];

        return newState;
      }

      break;

    case "layer/removeall":
      {
        return [];
      }

      break;

    case "layer/unshift":
      {
        let newState = [
          {
            id: action.payload.id,
            title: action.payload.title,
            type: "layer",
            expanded: true,
            checked: true,
            layer: action.payload,
          },
          ...state,
        ];

        return newState;
      }

      break;

    // case "layer/registeredlayertree/add": {
    //   let newState = [
    //     ...state,
    //     {
    //       id: action.payload.id,
    //       title: action.payload.title,
    //       type: "layer",
    //       expanded: true,
    //       checked: true,
    //       layer: action.payload,
    //     },
    //   ];

    //   return newState;
    // }

    case "layerTree/group/add":
      {
        let newState = [
          ...state,
          {
            id: action.payload.id,
            title: action.payload.title,
            type: "group",
            expanded: true,
            checked: true,
          },
        ];

        return newState;
      }

      break;

    case "layerTree/group/delete":
      {
        let newState = cloneDeep(state);

        walk({
          treeData: newState,
          getNodeKey: ({ treeIndex }) => treeIndex,
          ignoreCollapsed: true,
          callback: (rowInfoIter) => {
            if (rowInfoIter.node.id == action.payload) {
              newState = removeNodeAtPath({
                treeData: newState,
                path: rowInfoIter.path,
                getNodeKey: ({ node: TreeNode, treeIndex: number }) => {
                  return number;
                },
                ignoreCollapsed: true,
              });
            }
          },
        });

        return newState;
      }

      break;

    case "layerTree/state/update":
      {
        sortMapLayers(action.payload);
        return action.payload;
      }

      break;

    case "layer/deleteById":
      {
        let newState = cloneDeep(state);

        walk({
          treeData: newState,
          getNodeKey: ({ treeIndex }) => treeIndex,
          ignoreCollapsed: true,
          callback: (rowInfoIter) => {
            if (rowInfoIter.node.id == action.payload) {
              newState = removeNodeAtPath({
                treeData: newState,
                path: rowInfoIter.path,
                getNodeKey: ({ node: TreeNode, treeIndex: number }) => {
                  return number;
                },
                ignoreCollapsed: true,
              });

              removeLayerById(action.payload);
            }
          },
        });

        sortMapLayers(newState);

        return newState;
      }

      break;

    case "layer/get":
      {
        let newState = { ...state };

        return newState[action.payload];
      }
      break;

    case "loadconfiguration":
      {
        let newState = [...action.payload.layerTree];

        function reccursive(data) {
          return data?.map((el) => {
            if (el.type === "layer" && el.layer.source.type !== "GEOJSON") {
              el.id = getLayerIdByName(el.layer.name, el.layer.source.url);
              el.layer.id = getLayerIdByName(
                el.layer.name,
                el.layer.source.url
              );
              el.layer.source.id = md5(el.layer.source.url);
            }

            reccursive(el.children);

            return el;
          });
        }

        return reccursive(newState);
      }
      break;

    default:
      {
        let newState = [...state];

        function reccursive(data) {
          return data?.map((el) => {
            if (el.type === "layer") {
              el.id = getLayerIdByName(el.layer.name, el.layer.source.url);
              el.layer.id = getLayerIdByName(
                el.layer.name,
                el.layer.source.url
              );
              el.layer.source.id = md5(el.layer.source.url);
            }

            reccursive(el.children);

            return el;
          });
        }

        return reccursive(newState);
      }
      break;
  }
}
